import { List } from '@mui/material';
import { FC, PropsWithChildren } from 'react';

const DrawerList: FC<PropsWithChildren> = ({ children }) => (
  <List sx={{ padding: 0 }}>{children}</List>
);

export default DrawerList;
